import { AuthenticationLevel } from 'auth';
import { requiredLoginLevel } from 'utils/routes/requiredLoginLevel';
import { verifyRequiredBetaFeatures } from 'utils/betaFeatures/verifyRequiredBetaFeatures';
import redirectSubscribedUser from './utils/redirectSubscribedUser';

import {
  OR_REGISTRATION_BETA_FEATURES,
  OR_MANAGEMENT_BETA_FEATURES,
} from './const';

export default [
  {
    path: 'or-signup',
    onEnterHandlers: [
      requiredLoginLevel(AuthenticationLevel.REMEMBERED),
      redirectSubscribedUser,
    ],
    getComponent(location, callback) {
      import(/* webpackChunkName: "ordersReserved" */ './containers/signup/ORSignUpPage')
        .then(component => callback(null, component.default));
    },
    layoutNoGap: true,
  },
  {
    path: 'or-register',
    onEnterHandlers: [
      verifyRequiredBetaFeatures(OR_REGISTRATION_BETA_FEATURES),
      requiredLoginLevel(AuthenticationLevel.REMEMBERED),
    ],
    getComponent(location, callback) {
      import(/* webpackChunkName: "ordersReserved" */ './containers/registration/ORRegisterPage')
        .then(component => callback(null, component.default));
    },
    layoutNoGap: true,
  },
  {
    path: 'or-management',
    onEnterHandlers: [
      verifyRequiredBetaFeatures(OR_MANAGEMENT_BETA_FEATURES),
      requiredLoginLevel(AuthenticationLevel.REMEMBERED),
    ],
    getComponent(location, callback) {
      import(/* webpackChunkName: "ordersReserved" */ './containers/management/ORManagementPage')
        .then(component => callback(null, component.default));
    },
    layoutNoGap: true,
  },
];
